// extracted by mini-css-extract-plugin
export default {"option":"HeaderThemeSwitcher_option__8wrrW","name":"HeaderThemeSwitcher_name__a4qQN"};